const axios = require("axios")
const { mondelezAPI } = require("../constants/mondelezAPI.contants")

// product api headers
const headersValue = {
  appid: process.env.GATSBY_APP_ID,
}

const getAllCountriesResults = async () => {
  try {
    const result = await axios.post(
      `${process.env.GATSBY_JOBS_URL}/getActiveLocation`,
      {},
      {
        headers: headersValue,
      }
    )
    const apiOut = result?.data?.sort((a, b) =>
      a.countryName?.toLowerCase() > b.countryName?.toLowerCase()
        ? 1
        : b.countryName?.toLowerCase() > a.countryName?.toLowerCase()
        ? -1
        : 0
    )
    const apiOutSelect = apiOut?.map(field => {
      field?.locations?.sort((a, b) =>
        a.label > b.label ? 1 : b.label > a.label ? -1 : 0
      )

      field?.stateWithLocations?.sort((a, b) =>
        a.stateName > b.stateName ? 1 : b.stateName > a.stateName ? -1 : 0
      )
      field?.locations?.unshift({
        label: "Select location",
        value: "",
      })

      const stateData = field?.stateWithLocations?.map(stateLoc => {
        stateLoc?.locations?.sort((a, b) =>
          a.label > b.label ? 1 : b.label > a.label ? -1 : 0
        )
        stateLoc?.locations?.unshift({
          label: "Select location",
          value: "",
        })
        return stateLoc
      })
      field["stateWithLocations"] = stateData
      return field
    })
    return apiOutSelect || []
  } catch (error) {
    throw new Error(error)
  }
}

module.exports = { getAllCountriesResults }
